export enum DASHBOARD_PERIOD {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum DASHBOARD_DATA_TYPE_DISPLAYED {
  ENERGY = 'energy',
  POWER = 'power',
}

export enum DASHBOARD_CHART_TYPE {
  COLUMN = 'column',
}

export enum DASHBOARD_GRAPH_UNIT {
  KWH = 'kWh',
  KW = 'kW',
}
export enum GRAPH_VIEW {
  DAY_POWER = 'day_power',
  DAY_ENERGY = 'day_energy',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}
